<template>
	<form
		@submit.prevent="attemptSubmit"
		@keyup.enter.ctrl="triggerFormSubmit"
		:class="{'SimpleForm':1,submitting}"
		>

		<SimpleFormField
			v-for="(field,fieldindex) in visible_fields"
			v-if="!field.show_if || field.show_if(vals)"
			v-model="vals[field.name]"
			v-on:input="(v)=>{ valsUpdated(field.name,v); }"
			:ref="'field'+fieldindex"
			:type="field.type"
			:label="field.label"
			:label_help="field.label_help"
			:name="field.name"
			:placeholder="field.placeholder"
			:options="field.options"
			:validateValue="field.validateValue"
			:filterValue="field.filterValue"
			:autocomplete="field.autocomplete"
			:formQueue="formQueue"
			:wayleave="field.wayleave"
			:checkbox_label="field.checkbox_label"
			:key="field.name"
			:autofocus="field.autofocus || null"
			:required="field.required || null"
			/>

		<div :class="{field_submit:1,clickwrap:!!$slots.clickwrap}" v-if="!hideSubmit">
			<div v-if="$slots.clickwrap" class="clickwrap">
				<slot name="clickwrap" ></slot>
			</div>
			<span v-if="block_submit" class="submit_block" >{{ block_submit === true ? 'Unable to submit' : block_submit }}</span>
			<button :class="{'btn-a':1,'submit-button':1}" v-bind:disabled="!can_submit" ref="submitButton"  >{{ submitText || 'Submit' }}</button>
		</div>

		<input v-for="field in hidden_fields" type="hidden" :key="field.name" :name="field.name" v-model="vals[field.name]" />

	</form>
</template>

<script>

	import SimpleFormField from './SimpleFormField';

	export default {

		components : {
			SimpleFormField,
		},

		data() {
			return {
				all_fields_valid : false,
				submitting : false,
				open : false,
				vals : {},
				formQueue : [], // Form will wait until all promises in queue are complete
			};
		},

		computed : {
			block_submit : function(){
				return this.submitBlock ? this.submitBlock(this.vals) : false; // Bool or string
			},
			usable_fields : function(){
				return this.fields.filter( x => x.name );
			},
			visible_fields : function(){
				return this.usable_fields.filter( x => x.type != 'hidden' );
			},
			hidden_fields : function(){
				return this.usable_fields.filter( x => x.type == 'hidden' );
			},
			can_submit : function(){
				return !this.block_submit && this.all_fields_valid;
			}
		},

		props : [
			'fields',
			'model',
			'hideSubmit',
			'submitText',
			'onSubmit',
			'autofocus',
			'submitBlock', // optional function with form payload as parameter - if returns true or string, block form submit
			],

		watch : {
			'$route.path' : function(){
				this.open = false;
			},
			fields : function(){
				this.all_fields_valid = this.allFieldsValid();
			},
			model : function(){
				this.updateValsFromModel();
			},
		},

		created(){
			this.updateValsFromModel();
		},

		mounted(){
			var self = this;

			// If the form itself has an autofocus, force autofocus on first element
			setTimeout(function(){
				if(self.autofocus && self.$refs.field0 && ((self.$refs.field0[0].$refs||{}).input||{}).focus ){
					self.$refs.field0[0].$refs.input.focus();
				}
			},100);
		},

		methods: {

			updateValsFromModel(){
				var model_vals = this.model ? JSON.parse(JSON.stringify(this.model)) : {};
				var form_vals = {};
				for (var i = 0; i < this.fields.length; i++) {
					var k = this.fields[i].name;
					if(k) form_vals[k] = model_vals[k] || null;
				}
				this.vals = form_vals;
			},

			attemptSubmit(){
				var self = this;
				if(!self.can_submit) return false;
				self.submitting = true;
				self.completeAllWaitfors()
					.then(function(){
						self.submitForm();
					}).catch((error)=>{
						console.error(error);
						self.submitting = false;
					});
			},

			triggerFormSubmit(){
				 this.$refs.submitButton.click();
			},

			completeAllWaitfors(){
				var self = this;
				return Promise.all(self.formQueue || []);
			},

			valsUpdated(name,val){
				this.refreshState();
				this.$emit('change',this.vals);
			},

			submitForm(){
				this.submitting = true;
				this.onSubmit(this.vals)
					.catch((e)=>{
						console.error(e);
						alert(e && e.message ? e.message : 'Unknown error occurred');
					})
					.then(()=>{
						this.submitting = false;
					});
			},

			refreshState(){
				this.all_fields_valid = this.allFieldsValid();
			},

			allFieldsValid(){
				for (var i = 0; i < this.fields.length; i++) {
					var field = this.fields[i];
					var validator = field.validateValue || (()=>true);
					var value = this.vals[field.name]||'';
					if(field.required && !value) return false;
					if(!field.required && !value) continue;
					if(validator(value||'')!==true) return false;
				}
				return true;
			},

		}
	}

</script>